/* global $$epiforms */

// Bridges the gap between when EPiServer raises `formsSetupCompleted` and when the lazily
// loaded optimizely-forms chunk finishes evaluating.
//
// EPiServer raises the event with jQuery's `triggerHandler` (EPiServerForms.js:1736 ->
// raiseFormsEvent at :386), which dispatches only to listeners present at that instant. It is
// never replayed. The event is raised inside `$(document).ready()` (EPiServerForms.js:1682),
// so any subscriber that attaches after DOMContentLoaded misses it permanently.
//
// The subscription therefore has to be synchronous, but the 200 KB implementation chunk does
// not. This module is small enough to sit in the main bundle: it subscribes during parse and
// records each event, so the chunk can process them whenever it finishes loading.

const PENDING_KEY = '__optimizelyFormsPendingSetup';

// Tracks forms whose setup has already run, so a form is never processed twice when both the
// buffered path and the live subscription are active. Scoped to this module instance, which is
// safe because processing only ever happens on the chunk side.
const processedForms = new WeakSet();

function getPendingQueue() {
  if (!window[PENDING_KEY]) {
    window[PENDING_KEY] = [];
  }
  return window[PENDING_KEY];
}

/**
 * Subscribes synchronously and records `formsSetupCompleted` events for later processing.
 * Safe to call before the implementation chunk exists.
 */
export function bufferSetupCompletedEvents() {
  if (typeof $$epiforms === 'undefined') {
    return;
  }

  $$epiforms('.EPiServerForms').on('formsSetupCompleted', (e) => {
    getPendingQueue().push(e);
  });
}

/**
 * Runs `handler` for a form exactly once, regardless of how many paths deliver the event.
 * Returns true when the handler ran.
 */
export function processSetupCompleted(handler, event) {
  const form = event && event.currentTarget;

  if (!form || processedForms.has(form)) {
    return false;
  }

  processedForms.add(form);
  handler(event);
  return true;
}

/**
 * Processes any events recorded before the implementation chunk finished loading, then clears
 * the queue. Call this on chunk evaluation, before attaching the live subscription.
 */
export function drainBufferedSetupEvents(handler) {
  const pending = getPendingQueue();
  const drained = pending.splice(0, pending.length);

  drained.forEach((event) => processSetupCompleted(handler, event));
}
